import AMFlag from '@/assets/img/common/flags/AM.svg';
import AZFlag from '@/assets/img/common/flags/AZ.svg';
import BYFlag from '@/assets/img/common/flags/BY.svg';
import GEFlag from '@/assets/img/common/flags/GE.svg';
import KGFlag from '@/assets/img/common/flags/KG.svg';
import KZFlag from '@/assets/img/common/flags/KZ.svg';
import RUFlag from '@/assets/img/common/flags/RU.svg';
import TJFlag from '@/assets/img/common/flags/TJ.svg';
import UKFlag from '@/assets/img/common/flags/UK.svg';
import UZFlag from '@/assets/img/common/flags/UZ.svg';

export const flags = {
  RU: RUFlag,
  UK: UKFlag,
  AM: AMFlag,
  AZ: AZFlag,
  BY: BYFlag,
  GE: GEFlag,
  KG: KGFlag,
  TJ: TJFlag,
  KZ: KZFlag,
  UZ: UZFlag,
};
